var _rect, _rect2, _path, _rect3, _rect4, _circle, _path2, _rect5, _rect6, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    x: 5.5,
    y: 30.5,
    fill: "#FFEEE5",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    x: 5.5,
    y: 30.5,
    stroke: "#CC3D00",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC3D00",
    d: "M19.5 43.5v.5h.5v-.5h-.5Zm-9 0H10v.5h.5v-.5Zm4.5-10 .332-.374a.5.5 0 0 0-.664 0L15 33.5Zm-1.5 10v.5h.5v-.5h-.5Zm0-4V39H13v.5h.5Zm3 0h.5V39h-.5v.5Zm0 4H16v.5h.5v-.5Zm2.664-6.298.332-.374-.332.373Zm-8.328 0-.332-.374.332.373ZM11 43.5v-5.551h-1v5.55h1Zm8-5.551V43.499h1V37.948h-1Zm-7.832-.374 4.164-3.701-.664-.748-4.164 3.702.664.747Zm3.5-3.701 4.164 3.701.665-.747-4.165-3.702-.664.748ZM13.5 43h-3v1h3v-1Zm.5.5v-4h-1v4h1Zm-.5-3.5H16.5v-1H13.5v1Zm6 3h-3v1h3v-1ZM16 39.5v4h1v-4h-1Zm4-1.551a1.5 1.5 0 0 0-.503-1.121l-.665.747a.5.5 0 0 1 .168.374h1Zm-9 0a.5.5 0 0 1 .168-.374l-.664-.747a1.5 1.5 0 0 0-.504 1.12h1Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    x: 27.5,
    y: 30.5,
    fill: "#E3E8EF",
    rx: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    x: 27.5,
    y: 30.5,
    stroke: "#6A7585",
    rx: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 38.5,
    r: 5,
    stroke: "#6A7585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A7585",
    strokeLinecap: "round",
    d: "M34.5 38.5h4M36.5 40.5v-4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    x: 48.5,
    y: 30.5,
    fill: "#E3E8EF",
    rx: 2.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    x: 48.5,
    y: 30.5,
    stroke: "#6A7585",
    rx: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 38,
    r: 0.5,
    stroke: "#6A7585",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 38,
    r: 0.5,
    stroke: "#6A7585",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 38,
    r: 0.5,
    stroke: "#6A7585",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.eaa22f923be763e8779a46432554f1ed.svg";
export { ForwardRef as ReactComponent };